import PropTypes from 'prop-types'
import React from 'react'
import focusable from '../../components/Focusable/Focusable'
import StdButton from '../../components/StdButton/StdButton'
import tts from '../../lib/TTS'
import Modal from '../Modal/Modal'
import ErrorDescription from './ErrorDescription'
import googleAnalytics4 from '../../lib/googleAnalytics'
class ErrorModal extends React.Component {
  constructor(props) {
    super(props)

    this.componentType = props.componentType
    this.buttonRefs = []
    this.focusedIndex = 0
  }

  componentDidMount() {
    tts.pushTextToRead(this.props.title)
    tts.pushTextToRead(this.props.description ?? '')

    googleAnalytics4.sendPageViewEvent('Error (Modal)')
  }

  onKeyEvent(key) {
    let handled = false
    const multiButton = this.props.buttons.length === 2 ? true : false
    const { visible } = this.props

    if (!visible) {
      return false
    }

    if (visible) {
      if ('BACK' === key) {
        this.props.toggle && this.props.toggle()
      }

      switch (this.focusedIndex) {
        case 0:
          if ('DOWN' === key && multiButton) {
            this.focusedIndex = 1
            this.buttonRefs[this.focusedIndex]?.setFocus()
            tts.addTextToRead(
              `Focused on ${this.buttonRefs[this.focusedIndex].props.label}`
            )
          }
          break
        case 1:
          if ('UP' === key && multiButton) {
            this.focusedIndex = 0
            this.buttonRefs[this.focusedIndex]?.setFocus()
            tts.addTextToRead(
              `Focused on ${this.buttonRefs[this.focusedIndex].props.label}`
            )
          }
          break
        default:
          break
      }
    }

    return handled
  }

  setRefs = (key) => (component) => {
    if (null !== component && this.props.visible) {
      this.buttonRefs[key] = component

      if (key === 0) {
        tts.stopRead()
        this.buttonRefs[key]?.setFocus()
      }
    }
  }

  render() {
    const {
      componentType,
      title,
      description,
      error,
      buttons,
      visible,
      hideStationLogo,
    } = this.props

    return (
      <div className={`error-modal ${visible ? 'visible' : ''}`}>
        <Modal
          hideStationLogo={hideStationLogo}
          componentType={componentType}
          error={true}
        >
          {title ? <h1>{title}</h1> : null}
          {error ? (
            <ErrorDescription e={error} />
          ) : description ? (
            <p>{description}</p>
          ) : null}

          {buttons &&
            buttons.map((button, i) => {
              return (
                <StdButton
                  parent={this}
                  label={button.label}
                  disabled={!visible}
                  key={i}
                  link={false}
                  componentType={button.name}
                  onClick={button.onClick}
                  ref={this.setRefs(i)}
                >
                  {button.label}
                </StdButton>
              )
            })}
        </Modal>
      </div>
    )
  }
}

ErrorModal.propTypes = {
  buttons: PropTypes.array,
  componentType: PropTypes.string,
  description: PropTypes.string,
  error: PropTypes.error,
  hideStationLogo: PropTypes.bool,
  title: PropTypes.string,
  toggle: PropTypes.func,
  visible: PropTypes.bool,
}

export default focusable(ErrorModal)
